  <div class="editor">
    <button class="ant-btn ant-btn-primary d-flex align-items-center" (click)="configMode == 'basic' ? configMode = 'advanced' : configMode = 'basic'">
      <i nz-icon nzType="setting" nzTheme="outline"></i> 
      <span>{{(configMode == 'basic' ? 'cau_hinh_nang_cao' : 'cau_hinh_co_ban') | translate}}</span>
    </button>
    <!-- Cấu hình cơ bản -->
    <ng-container *ngIf="configMode == 'basic'">
      <div style="margin-top: 10px">
        <div class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label>{{'noi_dung' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="staticdata['placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'placeholder' : objectChoosing.component" 
              (ngModelChange)="staticdata['placeholder_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateContent('placeholder')">
            </textarea>
          </mat-form-field>
        </div>

        <nz-select [(ngModel)]="objectChoosing.staticdata.format" (ngModelChange)="updateStaticData()"
          nzPlaceHolder="{{'chon_thoi_gian' | translate}}" nzAllowClear>
          <nz-option [nzValue]="'dd-MM-yyyy'" nzLabel="{{'ngay_thang_nam' | translate}}"></nz-option>
          <nz-option [nzValue]="'MM-dd-yyyy'" nzLabel="{{'thang_ngay_nam' | translate}}"></nz-option>
          <nz-option [nzValue]="'yyyy-MM-dd'" nzLabel="{{'nam_thang_ngay' | translate}}"></nz-option>
          <nz-option [nzValue]="'MM-yyyy'" nzLabel="{{'thang_nam' | translate}}"></nz-option>
          <nz-option [nzValue]="'yyyy'" nzLabel="{{'nam' | translate}}"></nz-option>
        </nz-select>
      </div>
    </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label>{{'noi_dung' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="staticdata['placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'placeholder' : objectChoosing.component" 
              (ngModelChange)="staticdata['placeholder_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateContent('placeholder')">
            </textarea>
          </mat-form-field>
        </div>

        <nz-select [(ngModel)]="objectChoosing.staticdata.format" (ngModelChange)="updateStaticData()"
          nzPlaceHolder="{{'chon_thoi_gian' | translate}}" nzAllowClear>
          <nz-option [nzValue]="'dd-MM-yyyy'" nzLabel="{{'ngay_thang_nam' | translate}}"></nz-option>
          <nz-option [nzValue]="'MM-dd-yyyy'" nzLabel="{{'thang_ngay_nam' | translate}}"></nz-option>
          <nz-option [nzValue]="'yyyy-MM-dd'" nzLabel="{{'nam_thang_ngay' | translate}}"></nz-option>
          <nz-option [nzValue]="'MM-yyyy'" nzLabel="{{'thang_nam' | translate}}"></nz-option>
          <nz-option [nzValue]="'yyyy'" nzLabel="{{'nam' | translate}}"></nz-option>
        </nz-select>
      </li>
    </ul>

    <!-- Cấu hình hình dạng viền -->
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll"></div>
</div>